import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const CANCEL_UPLOAD_INTERNAL_BANNER_IMAGE = 'CANCEL_UPLOAD_INTERNAL_BANNER_IMAGE';
export type CANCEL_UPLOAD_INTERNAL_BANNER_IMAGE = typeof CANCEL_UPLOAD_INTERNAL_BANNER_IMAGE;
export interface CancelUploadInternalBannerImage {
    type: CANCEL_UPLOAD_INTERNAL_BANNER_IMAGE;
    bannerId: BannerId;
    resourceId: InternalResourceId;
}
export function cancelUploadInternalBannerImageAction(
    bannerId: BannerId,
    resourceId: InternalResourceId
): CancelUploadInternalBannerImage {
    return {
        type: CANCEL_UPLOAD_INTERNAL_BANNER_IMAGE,
        bannerId,
        resourceId
    };
}
